import React from "react";
import cx from "classnames";

/** Ordena entradas de `dependencies` do input (auto_generated) para render estável. */
export function sortDependenciesObject(dependencies) {
  if (!dependencies || typeof dependencies !== "object") return [];
  const entries = Object.entries(dependencies).map(([key, value]) => {
    return {
      label: JSON.parse(key),
      position: value.position,
      data: value.data,
    };
  });
  entries.sort((a, b) => a.position - b.position);
  return entries;
}

export function getResponsible(usersList, responsible, classes) {
  const responsible_data = usersList.filter((u) =>
    responsible.map((r) => r.id).includes(u.id),
  );
  return (
    <>
      {responsible_data.map((resp, key) => {
        return (
          <span
            key={key}
            className={cx({
              [classes.inputDrawerTag]: true,
              ["no-hover"]: true,
            })}
          >
            {resp.name}
          </span>
        );
      })}
    </>
  );
}
